import React, {useState} from 'react'
import {Headers} from '../../types'
import {useQuery} from 'react-query'
import {Get} from '../../../../../../setup'
import {ExtendedCampaignInterface} from '../../../../../../app/pages/mailing/campaigns/types'
import {useMailing} from '../../../../../../app/@types'
import {DataTableWebForm} from '../../components/DataTable.web-form'

const headers: Headers<ExtendedCampaignInterface>[] = [
  {key: 'archived_at', label: 'Date d\'envoi', className: 'fw-bolder text-muted bg-light min-w-150px'},
  {key: 'name', label: 'Titre', className: 'fw-bolder text-muted bg-light min-w-200px'},
  {key: 'subject', label: 'Sujet', className: 'fw-bolder text-muted bg-light min-w-250px'},
  {key: 'from_email', label: 'E-mails', className: 'fw-bolder text-muted bg-light min-w-150px'},
  {key: 'open_count', label: 'Ouvertures', className: 'fw-bolder text-muted bg-light min-w-100px'},
  {key: 'click_count', label: 'Clics', className: 'fw-bolder text-muted bg-light min-w-100px'},
]

const ARCHIVED = process.env.REACT_APP_MAILING_ARCHIVER_CAMPAIGN || 'v2/campaigns-archiver'

const TablesWidget21 = () => {

  const {reloadKey} = useMailing()
  const [data, setData] = useState<ExtendedCampaignInterface[]>([])

  useQuery(
    [`MAILING_CAMPAIGN_ARCHIVED`, reloadKey],
    () => Get<{campaigns: ExtendedCampaignInterface[]}>({endpoint: ARCHIVED}),
    {
      onSuccess: ({campaigns}) => setData(campaigns),
    },
  )

  return <DataTableWebForm headers={headers} data={data} favorite={false} />
}

export {TablesWidget21}